export function getFormattedName(user, nameOption, userAddr) {
  if (!nameOption || nameOption === "firstname") {
    return user.firstName
  } else if (nameOption === "lastname") {
    if (userAddr && userAddr.civility && userAddr.civility.label) {
      return `${userAddr.civility.label} ${user.lastName}`
    }
    return `${user.firstName} ${user.lastName}`
  }
  return ""
}

function getFirstNameLabel(title, firstname) {
  const name = firstname || "";
  return title.replace(
    "{{firstname}}",
    "<strong>" + name + "</strong>"
  );
}

function getLastNameLabel(user, name, userAddr, title) {
  const formatName = getFormattedName(user, name, userAddr)
  return title.replace(
    "{{name}}",
    "<strong>" + formatName + "</strong>"
  )
}

export function getNameLabel(title, user, userAddr, name) {
  if (title.indexOf("firstname") === -1) {
    return getLastNameLabel(user, name, userAddr, title)
  }

  return getFirstNameLabel(title, user.firstName)
}
